import { defineAdderTests } from '@svelte-add/core';
import { options } from './options.js';

export const tests = defineAdderTests({
	files: [],
	options,
	optionValues: [],
	tests: [],
});
